<template>
  <div v-click-outside="hideNav">
    <div class="navbar-container"
        :class="{ 'navbar-hidden': !showNavbar }">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <header class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div @click="scrollTop" class="logo pointer">
                  <router-link to="/experts">
                    <img src="@/assets/LOGO_color_experts.svg" class="img-fluid" alt="logo">
                  </router-link>
                </div>
              </div>
              <transition name="fade-down-desktop">
                <SearchForm v-if="!isEmptyObject(this.selectedProductCategory) || $route.name !== 'Home'" :forNavbar="true"/>
              </transition>

              <div class="nav-switchers d-flex align-items-center">
                <div class="mr-md-2">
                  <Newsletter/>
                </div>
                <div class="mr-lg-4">
                  <LangSelect/>
                </div>
                <div class="main-nav-toggler pointer" @click="openNav">
                  <img src="@/assets/icons/nav-toggle.svg" class="img-fluid">
                </div>
              </div>
            </header>
          </div>
        </div>
      </div>
    </div>
    <MainMenu :menuVisible="menuVisible" @hideNav="hideNav"/>
    <TopMenu/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ClickOutside from 'vue-click-outside';
import LangSelect from '@/components/LangSelect.vue';
import MainMenu from '@/components/MainMenu.vue';
import TopMenu from '@/components/TopMenu.vue';
import SearchForm from './SearchForm.vue';
import Newsletter from './Newsletter.vue';

export default {
  name: 'Header',
  components: {
    LangSelect,
    SearchForm,
    MainMenu,
    TopMenu,
    Newsletter,
  },
  computed: {
    ...mapGetters({
      selectedProductCategory: 'threeSteps/selectedProductCategory',
    }),
  },
  data() {
    return {
      menuVisible: false,
      showNavbar: true,
      lastScrollPosition: 0,
      activeRoute: '',
    };
  },
  methods: {
    openNav() {
      this.menuVisible = true;
    },
    hideNav() {
      this.menuVisible = false;
    },
    onScroll() {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      if (currentScrollPosition < 0) {
        return;
      }
      // Stop executing this function if the difference between
      // current scroll position and last scroll position is less than some offset
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 100) {
        return;
      }
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      this.lastScrollPosition = currentScrollPosition;
    },
    scrollTop() {
      window.scroll(0, 0);
    },
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
  directives: {
    ClickOutside,
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/common.scss';

.navbar-container {
  position: fixed;
  top: 0;
  width: 100%;
  background-color: rgba(255,255,255, .9);
  z-index: 999;
  transform: translate3d(0, 0, 0);
  transition: 0.3s all ease-out;
  &.navbar-hidden {
    transform: translate3d(0, -100%, 0);
  }
}
header {
  width: 100%;
  padding: .5rem 0 .7rem 0;
  @include media-breakpoint-down(sm) {
    flex-wrap: wrap;
    .logo {
      max-width: 150px;
    }
    .search-form {
      margin: 0 auto;
      input {
        font-size: 10px;
      }
      img {
        width: 16px!important;
      }
    }
    .nav-switchers {
      .main-nav-toggler {
        width: 35px;
      }
    }
  }
}
.logo {
  max-width: 335px;
  padding: 1rem;
  @include media-breakpoint-down(md) {
    max-width: 215px;
  }
}

.main-nav-toggler {
  width: 40px;
  padding: 5px;
}
</style>
